export function logError(context: string, error: unknown, meta?: Record<string, any>) {
  console.error(JSON.stringify({
    level: "error",
    timestamp: new Date().toISOString(),
    context,
    message: error instanceof Error ? error.message : String(error),
    stack: error instanceof Error ? error.stack : undefined,
    ...meta,
  }));
}